import { createSelector } from 'reselect'

import { None, none } from '../../utils/strictNull'

import { userSelector } from './user.selectors'

export const userEmailSelector = createSelector(userSelector, (u): string | None => (u && u.email ? u.email : none))
